















































































import { Component, Vue } from "vue-property-decorator";
import FormValidations from "@/helpers/validations";
import { Auth } from "aws-amplify";
import { LayoutModule } from "@/store/layout";
import { Alert } from "@/models/general";
import { UserModule } from "@/store/user";

@Component
export default class Login extends Vue {
  showPassword = false;
  appLogo = require("@/assets/app-logo.png");
  formValidations = new FormValidations();
  loading = false;

  model = {
    email: "",
    password: "",
  };

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.login() : null;
  }

  async login(): Promise<void> {
    this.loading = true;
    LayoutModule.cleanAlerts();
    try {
      const user = await Auth.signIn(this.model.email, this.model.password);
      UserModule.setCognitoUser(user);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        this.$router.push({ name: "complete-registration" });
        // Auth.completeNewPassword(user, this.model.password);
      } else {
        this.$router.push({ name: "home" });
      }
    } catch (error) {
      const e: Alert = {
        type: "error",
        text: this.$t(`auth.responses.${error.name}`).toString(),
      };

      LayoutModule.setAlerts(e);
    } finally {
      this.loading = false;
    }
  }
}
